var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<form name=\"vm.detailForm\"><div layout-gt-xs=\"row\" layout-padding=\"layout-padding\"><div flex=\"flex\" layout=\"row\"><div flex=\"25\" class=\"form-group\"><label for=\"companyName\" class=\"control-label\">Company Name</label><input name=\"companyName\" placeholder=\"Company Name\" ng-model=\"vm.docSvc.doc.companyName\" class=\"form-control\"/></div><div flex=\"25\" class=\"form-group\"><label for=\"firstName\" class=\"control-label\">First Name</label><input name=\"firstName\" placeholder=\"First Name\" ng-model=\"vm.docSvc.doc.firstName\" class=\"form-control\"/></div><div flex=\"25\" class=\"form-group\"><label for=\"lastName\" class=\"control-label\">Last Name</label><input name=\"lastName\" placeholder=\"Last Name\" ng-model=\"vm.docSvc.doc.lastName\" class=\"form-control\"/></div></div></div></form>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/customers/customers/tabs/top-panel.jade
// module id = 253
// module chunks = 0